import React, { useState } from "react";
import classNames from "classnames/bind";
import s from "./SkillsEdit.module.scss";
import { AnimatePresence } from "framer-motion";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";
import {
  Button,
  Chip,
  TextField,
  Badge,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { updateReduxKey, setViewType, setAdditionalSections } from "../MainLayout/action";
import { useRef } from "react";
import { SECTION } from "../../constants/constants";
import Rating from "@material-ui/lab/Rating";

const SkillsEdit = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  const { skills } = props.initialData;
  const { language } = props.additionalSections;
  const dataArray = props.isLanguage ? [...language.data]: [...skills];
  const propsViewType = props.isLanguage ? props.viewType.language : props.viewType.skills;
  const inuptRef = useRef(null);
  const [localSkills, setLocalSkills] = useState(dataArray);
  const [viewType, setViewType] = React.useState(propsViewType);

  const handleChange = (event) => {
    setViewType(event.target.value);
  };

  const handleChipDelete = (item) => {
    setLocalSkills(localSkills.filter((x) => x.name !== item.name));
  };

  const addSkill = (evt) => {
    evt.preventDefault();
    const inputValue = inuptRef.current.elements["skills-input"].value;
    const ratingValue = inuptRef.current.elements["rating-comp"].value;
    const isSkillExists = localSkills.find((x) => x.name === inputValue.name);
    if (inputValue && !isSkillExists) {
      localSkills.unshift({
        name: inuptRef.current.elements["skills-input"].value,
        value: ratingValue,
      });
      setLocalSkills([...localSkills]);
      inuptRef.current.elements["skills-input"].value = "";
      props.setSnackBarData({
        open: true,
        message: SECTION.SKILLS.SKILL_ADDED,
      });
    }
  };

  const saveSkills = () => {
    if (props.isLanguage) {
      props.setAdditionalSections({
        key: "language",
        value: localSkills
      });
      props.updateViewType({
        language: viewType,
      });
      props.setSnackBarData({
        open: true,
        message: SECTION.SAVED_SECTION("Section"),
      });
    } else {
      props.storeEditedSkills({
        skills: localSkills,
      });
      props.updateViewType({
        skills: viewType,
      });
      props.setSnackBarData({
        open: true,
        message: SECTION.SKILLS.SKILL_SAVED,
      });
    }
    props.setPopOverData({
      currentTarget: null,
      content: "",
    });
    
  };

  return (
    <AnimatePresence>
      <div className={cx(s.container)}>
        <div className={cx(classes.primaryThemeColor, s.sectionHeading)}>
          <span>Edit {props.isLanguage ? 'Language' : 'Skills'}</span>
          <section className={s.optionsContainer}>
            <FormControl className={s.formControl}>
              <InputLabel id="demo-simple-select-label">View Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={viewType}
                onChange={handleChange}
              >
                <MenuItem value={"default"}>Default </MenuItem>
                <MenuItem value={"rating"}>Rating</MenuItem>
                <MenuItem value={"progress"}>Progress Bar</MenuItem>
              </Select>
            </FormControl>
          </section>
          <form
            ref={inuptRef}
            onSubmit={addSkill}
            className={s.textFieldContainer}
          >
            <TextField
              name="skills-input"
              label={props.isLanguage ? "New Language": "New Skill"}
              id="outlined-size-small"
              // defaultValue="Small"
              variant="outlined"
              size="small"
            />
            <Rating
              className={classes.rating}
              name="rating-comp"
              defaultValue={3.5}
              precision={0.5}
            />
            <Button
              // disabled={!inuptRef.current.elements["skills-input"].value}
              onClick={addSkill}
              variant="contained"
              size="small"
              color="primary"
            >
              Add
            </Button>
          </form>
          <section className={s.skillsContainer}>
            {localSkills.map((x, index) => {
              return (
                <Badge key={index} badgeContent={x.value} color="primary">
                  <Chip
                    label={x.name}
                    size="small"
                    onDelete={() => handleChipDelete(x)}
                  />
                </Badge>
              );
            })}
          </section>
        </div>

        <div className={s.actionContainer}>
          <Button
            onClick={saveSkills}
            variant="contained"
            size="small"
            color="primary"
          >
            Save {props.isLanguage ? 'Languages' : 'Skills'}
          </Button>
        </div>
      </div>
    </AnimatePresence>
  );
};

const mapStateToProps = (state) => ({
  ...state.mainLayoutReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    storeEditedSkills: (skillsObj) => {
      updateReduxKey(skillsObj)(dispatch);
    },
    updateViewType: (viewType) => {
      setViewType(viewType)(dispatch);
    },
    setAdditionalSections: (additionalSection)=>{
      setAdditionalSections(additionalSection)(dispatch);
    },
    dispatch,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SkillsEdit)
);

const compClasses = (theme) => ({
  // button: {
  //   backgroundColor: theme.palette.primary.main,
  //   margin: "0 10px 10px 0",
  //   "&:hover": {
  //     backgroundColor: theme.palette.primary.main,
  //     cursor: "default",
  //   },
  // },
  // iconDetailOverride: {
  //   height: "0.7em",
  //   width: "0.7em",
  // },
  rating: {
    color: theme.palette.primary.main,
  },
});
